// extracted by mini-css-extract-plugin
export var found = "StockTakeItem-module--found--qCnpl";
export var iconWrapper = "StockTakeItem-module--iconWrapper--VdiWq";
export var imageWrapper = "StockTakeItem-module--imageWrapper--q2cc3";
export var noItems = "StockTakeItem-module--noItems--CAXMd";
export var noteOrderStatus = "StockTakeItem-module--noteOrderStatus--sV0nK";
export var notfound = "StockTakeItem-module--notfound--bqguD";
export var statusBulb = "StockTakeItem-module--statusBulb--tF7Sr";